















import Vue from 'vue';
import ArrowIcon from '../../../icons/ArrowIcon.vue';

export default Vue.extend({
  name: `FrontpageButton`,
  components: { ArrowIcon },
  props: {
    borderless: {
      default: false,
      type: Boolean,
    },
    light: {
      default: false,
      type: Boolean,
    },
    text: {
      required: true,
      type: String,
    },
  },
  methods: {
    emitClick(): void {
      this.$emit(`click`);
    },
  },
});
